window.notifyWaitry = function(){
    $crisp.push(["do", "chat:open"]);
    $crisp.push(["do", "message:send", ["text", "Hola! El dominio "+window.location.hostname+" ya se encuentra configurado"]]);
}